<template>
  <div class="leftMenu light-scrollbar" v-if="brandList.length > 0">
    <div
      class="menuItem"
      :class="{ menuChecked: activeIndex === index }"
      v-for="(item, index) in brandList"
      :key="index"
      @click="onCheck(index)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import { elementIsVisibleInViewport, scrollIntoView } from '@/utils'

export default {
  props: {
    brandList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeIndex: '',
      scrollTop: 0
    }
  },
  computed: {},
  mounted () {
    window.addEventListener('scroll', this.getVisible)
  },
  destroyed () {
    window.removeEventListener('scroll', this.getVisible)
  },
  methods: {
    onCheck (index) {
      const id = 'contentInfoFloor_' + index
      const dom = document.getElementById(id)

      scrollIntoView(dom, 0)
    },
    // 获取哪些模块在视图里
    getVisible () {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop

      const visibleIndex = this.visibleIndex()
      if (visibleIndex.length >= 1) {
        this.$nextTick(() => {
          this.activeIndex = visibleIndex[0]
        })
      }
    },
    // 返回视图内的相应序号
    visibleIndex () {
      let jumpArr = []
      let allSides = []

      const homeDynamicsDom = document.getElementById('contentInfo-dynamics')

      if (homeDynamicsDom) {
        [...homeDynamicsDom.children].forEach((item) => {
          const targetDom = item
          if (targetDom) {
            allSides.push(targetDom)
          }
        })
      }
      allSides.forEach((item, index) => {
        elementIsVisibleInViewport(item, true, 0, 400) && jumpArr.push(index)
      })
      return jumpArr
    }
  }
}
</script>

<style lang="scss" scoped>
.leftMenu {
  width: 120px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 16px;
  background: #f5f6fa;
  padding: 2px;

  position: fixed;
  top: 50vh;
  z-index: 999;
  transform: translateY(-50%);
  left: calc(50% - 600px - 120px - 40px);

  @media screen and(max-width: 1500px) {
    left: 2%;
  }

  .menuItem {
    border-radius: 14px;
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #666666;
    text-align: center;
    padding: 8px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .menuChecked {
    color: #2a54d1;
    font-weight: bold;
    background: #ffffff;
  }
}
</style>
